export enum StartNowAppOfflineMessages {
  DefaultMessage = 'DefaultMessage',
  AfterCardPayment = 'AfterCardPayment',
}
